import { ServiceOrderState } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { createHandler } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { Tag, TagVariant } from '@optimus-web/core';

const getTextServiceOrderState = createHandler<ServiceOrderState, Mews.TextKey>(
    {
        [ServiceOrderState.Confirmed]: TextKey.Confirmed,
        [ServiceOrderState.Processed]: TextKey.Processed,
        [ServiceOrderState.Canceled]: TextKey.Canceled,
        [ServiceOrderState.Inquired]: TextKey.Inquired,
        [ServiceOrderState.Optional]: TextKey.Optional,
        [ServiceOrderState.Requested]: TextKey.Requested,
        [ServiceOrderState.Started]: TextKey.Started,
    },
    TextKey.Processed
);

const getTagVariantFromServiceOrderState = createHandler<ServiceOrderState, TagVariant>(
    {
        [ServiceOrderState.Confirmed]: 'primary',
        [ServiceOrderState.Processed]: 'success',
    },
    'basicBold'
);

interface ServiceOrderStateTagProps {
    serviceOrderState: ServiceOrderState;
}

export const ServiceOrderStateTag = ({ serviceOrderState }: ServiceOrderStateTagProps) => {
    const textKey = getTextServiceOrderState(serviceOrderState);
    const variant = getTagVariantFromServiceOrderState(serviceOrderState);
    return (
        <Tag variant={variant}>
            <LocalizedText textKey={textKey} />
        </Tag>
    );
};
